import FirebaseContext, { withFirebase } from './firebase/Context';
import Firebase from './firebase/Firebase';

export default Firebase;

export { FirebaseContext, withFirebase };